/**
 * @module builder
 */
import type { RatesDocument } from 'paintscout'

// Clean Rates Document of PK and SK fields
export function cleanRates(args: { rates: RatesDocument }): RatesDocument {
  const { rates: dirtyRates } = args

  const cleanRates: RatesDocument = {
    ...dirtyRates
  }

  delete cleanRates.PK
  delete cleanRates.SK

  return cleanRates
}
